var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"document"},[_vm._v("\n\n\tccccc\n\t"),_c('button',{on:{"click":_vm.exportToPDF}},[_vm._v("Export to PDF")])])}
var staticRenderFns = []

export { render, staticRenderFns }